var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRatesInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_463_32625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1729 9.31348L10.9546 10.0017H6.875L7.09635 9.31348H11.1729ZM9.1223 13.38L6.9703 11.1681L6.96723 10.5849H8.03093C8.28507 10.5849 8.4972 10.549 8.66731 10.4772C8.83947 10.4037 8.96961 10.3012 9.05774 10.1699C9.14792 10.0368 9.19301 9.8809 9.19301 9.70227C9.19301 9.43432 9.10078 9.21891 8.91633 9.05604C8.73187 8.89316 8.43674 8.81173 8.03093 8.81173H6.875L7.11479 8H8.03093C8.54741 8 8.97474 8.0683 9.31291 8.2049C9.65313 8.33975 9.90727 8.53064 10.0753 8.77758C10.2454 9.02451 10.3305 9.31348 10.3305 9.64447C10.3305 9.93694 10.268 10.1979 10.143 10.4273C10.0179 10.6567 9.82119 10.845 9.5527 10.9921C9.28421 11.1392 8.93272 11.2373 8.49822 11.2863L8.46133 11.2968L10.4043 13.3327V13.38H9.1223ZM11.179 8L10.9546 8.69877L7.64665 8.68826L7.87107 8H11.179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.625 15.75H3.375C3.07673 15.7497 2.79076 15.6311 2.57985 15.4201C2.36894 15.2092 2.25031 14.9233 2.25 14.625V6.75C2.25031 6.45173 2.36894 6.16576 2.57985 5.95485C2.79076 5.74394 3.07673 5.62531 3.375 5.625H14.625C14.9233 5.62531 15.2092 5.74394 15.4201 5.95485C15.6311 6.16576 15.7497 6.45173 15.75 6.75V14.625C15.7497 14.9233 15.6311 15.2092 15.4201 15.4201C15.2092 15.6311 14.9233 15.7497 14.625 15.75ZM3.375 6.75V14.625H14.625V6.75H3.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.625 3.375H3.375V4.5H14.625V3.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 1.125H4.5V2.25H13.5V1.125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_463_32625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatesInventory);
export default __webpack_public_path__ + "static/media/ratesInventory.b00bdac789cf96a2f990c2643c25a6bf.svg";
export { ForwardRef as ReactComponent };